module.exports = __webpack_public_path__ + "static/media/pay.63e32956.png";